(function () {
    'use strict';

    angular
        .module('core')
        .service('dataConfigService', dataConfigService);

    dataConfigService.$inject = ['$cookies', '$window', 'columnsCookieName'];
    function dataConfigService($cookies, $window, columnsCookieName) {
        var that = this;
        var LT = '<', LTE = '<=', GT = '>', GTE = '>=', EQ = '=', NEQ = '<>', LIKE = 'LIKE', IN = 'IN';
        this.config = [
            getParameterObj('road.id', 'Kelio Nr', 'kelioNumeris', 'road', true, '+', [EQ, NEQ], null, 'kelioSvarba'),
            getParameterObj('kelioPavadinimas', 'Kelias', 'kelioPavadinimas', null, true, '', null, 620),
            getParameterObj('kmFrom', 'Km nuo', 'kmNuo', 'number', true, '+', [EQ, NEQ, LT, LTE, GT, GTE], null),
            getParameterObj('kmTo', 'Km iki', 'kmIki', 'number', true, '', [EQ, NEQ, LT, LTE, GT, GTE], null),
            getParameterObj('address', 'Adresas', 'adresas', 'text', true, '', [EQ, NEQ, LIKE], 1300),
            getParameterObj('re.division.id', 'Regionas', 'regionuPavadinimai', 'regions', true, '', [EQ, NEQ], 1000, 'regionuPavadinimai'),
            getParameterObj('rs.division.id', 'Tarnyba', 'tarnybuPavadinimai', 'services', true, '', [EQ, NEQ], 900, 'tarnybuPavadinimai'),
            getParameterObj('ma.division.id', 'Meistrija', 'meistrijuPavadinimai', 'masteries', true, '', [EQ, NEQ], 900, 'meistrijuPavadinimai'),
            getParameterObj('vi.possibleViolation.id', 'Pažeidimai', 'defektuGrupiuPavadinimai', 'violations', true, '', [EQ, NEQ], 470, 'defektuGrupiuPavadinimai'),
            getParameterObj('defectStatus', 'Defekto statusas', 'defektoStatusas', 'status', true, '', [EQ, NEQ, IN], 425, 'defektoStatusas'),
            getParameterObj('workType', 'Darbų rūšis', 'darbuRusisMeaning', 'workType', true, '', [EQ, NEQ], 425, 'darbuRusisMeaning'),
            getParameterObj('inspectionDate', 'Apžiūros data', 'apziurosData', 'date', true, '', [EQ, NEQ, LT, LTE, GT, GTE], 750, null, 2),
            getParameterObj('decisionDate', 'Sprendimo data', 'sprendimoData', 'date', true, '', [EQ, NEQ, LT, LTE, GT, GTE], 750, null, 2),
            getParameterObj('updateDate', 'Redagavimo data', 'redagavimoData', 'date', false, '', [EQ, NEQ, LT, LTE, GT, GTE], 0, null, 1),
            getParameterObj('author.id', 'Sukūręs naudotojas', 'sukuresNaudotojas', 'user', true, '', [EQ, NEQ], 1100, 'sukuresNaudotojas'),
            getParameterObj('description', 'Aprašymas', 'aprasymas', 'text', true, '', [LIKE], 620),
            getParameterObj('statusChangeDate', 'Paskutinė statuso keitimo data', 'statusoKeitimoData', 'date', true, '', [EQ, NEQ, LT, LTE, GT, GTE], 750, null, 2),
        ];

        this.setShownColumns = setShownColumns;
        this.setColumnsToCookie = setColumnsToCookie;
        this.getOrder = getOrder;

        ////////////////

        function setShownColumns() {
            var cookie = $cookies.get(columnsCookieName);
            if (cookie) {
                var columns = cookie.split(';');
                _.forEach(that.config, function (configColumn) {
                    configColumn.show = _.includes(columns, configColumn.variable);
                });
            } else {
                _.forEach(that.config, function (configColumn) {
                    if (configColumn.show) {
                        configColumn.show = configColumn.minWidth == null || configColumn.minWidth < $window.innerWidth;
                    }
                });
            }
        }

        function setColumnsToCookie() {
            var cookieValue = '';
            _.forEach(that.config, function (column) {
                if (column.show) {
                    cookieValue += column.variable + ';';
                }
            });

            $cookies.put(columnsCookieName, cookieValue);
        }

        function getParameterObj(parameter, parameterName, variable, type, show, order, operands, minWidth, orderColumn, isDate) {
            return {
                parameter: parameter,
                parameterName: parameterName,
                variable: variable,
                show: show,
                order: order,
                orderColumn: orderColumn,
                type: type,
                operands: operands,
                minWidth: minWidth,
                isDate: isDate
            }
        }

        function getOrder() {
            var result = [];
            angular.forEach(that.config, function (column) {
                if (column.order !== '') {
                    result.push(column.order + (column.orderColumn ? column.orderColumn : column.variable));
                }
            })
            return result;
        }

    }
})();
